import { configureStore } from '@reduxjs/toolkit'
import userSlice from '../features/auth/userSlice'

export default configureStore({
  reducer: {
    user: userSlice
  }
})
